import useFlag from 'hooks/useFlag'
import React from 'react'
import PushLegacy from './PushLegacy'
import PushRedesigned from './PushRedesigned'

type Props = {
  text: string | null
  title?: string | null
  subtitle?: string | null
  imageUrl?: string | null
}

// Kill-switch dispatcher for the DATA-4894 push preview redesign. When
// `mx-push-composer-redesign` is off (prod default) we render the pre-DATA-4894
// static notification card; when on, the iOS/Android device-mockup preview.
// The redesign-only props (title/subtitle/imageUrl) are ignored by the legacy
// card.
const Push = ({ text, title, subtitle, imageUrl }: Props) => {
  const showRedesign = useFlag('mx-push-composer-redesign', false)

  return showRedesign ? (
    <PushRedesigned
      text={text}
      title={title}
      subtitle={subtitle}
      imageUrl={imageUrl}
    />
  ) : (
    <PushLegacy text={text} />
  )
}

export default React.memo<Props>(Push)
